console.log('Custom appstle script');

let appstle_block = document.querySelector('.appstle_sub_widget');

const getElementBasedOnClassname = (elements, classnames) => {
  if (!elements?.length || !classnames?.length) return null;

  for (const element of elements) {
    for (const classname of classnames) {
      const isMatched = Array.from(element.classList).some(cls => cls.includes(classname));
      if (isMatched) return element;
    }
  }

  return null;
};

const CustomAppstleFunction = () => {
  const appstle_block = document.querySelector('.appstle_sub_widget');
  const cstm_appstle_data = document.querySelector('#custom-appstle-data');

  if(!appstle_block) return;

  const subscriptions = appstle_block.querySelectorAll('.appstle_subscription_wrapper_option');

  if(subscriptions.length > 0 && cstm_appstle_data) {
    const appstle_data = JSON.parse(cstm_appstle_data.textContent);
    const priceWrapperCls = ['amount_wrapper', 'price_wrapper'];
    const labelWrapperCls = ['_text'];

    console.log(appstle_data);

    subscriptions.forEach((subscription, index) => {
      const cstmData = appstle_data[index];
      const allElements = subscription.querySelectorAll('*');
    
      const label = getElementBasedOnClassname(allElements, labelWrapperCls);
      const priceContainer = getElementBasedOnClassname(allElements, priceWrapperCls);
    
      if (!label || !priceContainer) return;
    
      // Compose the updated label
      const originalLabel = label.innerHTML;
      const price = priceContainer.innerHTML;
      const updatedLabel = `${cstmData.tag && cstmData.tag } ${originalLabel} - ${price}`;
    
      // Update the label and remove the price container
      label.innerHTML = updatedLabel;
      priceContainer.remove();
    
      // Add optional tag and description
      const tag = cstmData.tag ? `<div class="cstm-appstle-tag">${cstmData.tag}</div>` : '';
      const desc = cstmData.desc ? `<div class="cstm-appstle-desc">${cstmData.desc}</div>` : '';
    
      if (tag) subscription.innerHTML += tag;
      if (desc) subscription.innerHTML += desc;
    
      // Re-apply the updated label on click (if the app resets it)
      setInterval(() => {
        const updatedLabelElement = getElementBasedOnClassname(subscription.querySelectorAll('*'), labelWrapperCls);
        if (updatedLabelElement) {
          updatedLabelElement.innerHTML = updatedLabel;
        }
      }, 300)
    });
  }
}

const getAppstle = () => {
  const interval = setInterval(() => {
    appstle_block = document.querySelector('.appstle_sub_widget');

    if(appstle_block) {
      CustomAppstleFunction();
      clearInterval(interval);
    }
  }, 300);
}

window.addEventListener('DOMContentLoaded', getAppstle);